import React, {useCallback, useState} from "react";
import fitpro from "../../assets/images/fitpro.png";
import {isValidImage} from "../../utils/isValidImage";
import {ToogleField} from "../../components/common/Toggle";
import {toast} from "react-toastify";

const useDebounce = (func, delay) => {
  const [timeoutId, setTimeoutId] = useState(null);

  return useCallback(
    (...args) => {
      if (timeoutId) clearTimeout(timeoutId);
      const id = setTimeout(() => func(...args), delay);
      setTimeoutId(id);
    },
    [timeoutId, func, delay]
  );
};

const UpdateRecipeTagTable = ({
                                 header,
                                 plans,
                                 error,
                                 convertTimestamp,
                                 handleStatusUpdate,
                                 selectedTags,
                                 handleToggleStatusUpdate,
                                 fetchPlans
                               }) => {

  // const debouncedStatusUpdate = useDebounce(handleStatusUpdate, 500);
  const debouncedStatusUpdate = useDebounce(async (id, planTag) => {
    await handleStatusUpdate(id, planTag);
    fetchPlans();
  }, 50);
  const toggleStatus = async (plan) => {
    // Create a new object instead of modifying directly (React won't detect updates otherwise)
    const updatedPlan = { ...plan, status: !plan.status };
    const fileName = null;

    const updatedFile = new File([JSON.stringify(updatedPlan)], fileName, {
      type: "application/json",
    });

    const formData = new FormData();
    formData.append("file", updatedFile, fileName);
    const response = await handleToggleStatusUpdate(formData, fileName);
    if (response) {
      showToast(
        `Success! detail update success.`,
        true
      );
      fetchPlans()
    }
  }


  const showToast = (message, success) => {
    success ? toast.success(message) : toast.error(message);
  };

  return (
    <div className="col-sm-12 workout-table-container" >
      <div className="scrollable-table">
        <table
          className="table-custom m-0"
          width="100%"
          cellPadding="0"
          cellSpacing="0"

        >
          <thead
            style={{
              position: "sticky",
              top: "0",
              backgroundColor: "#fff",
              zIndex: "1",
              margin:0
            }}
          >
          <tr>
            {header.map((heading, index) => (
              <th key={index} width={heading.width}>
                {heading.label}
              </th>
            ))}
          </tr>
          </thead>

          {error ? (
            <tbody>
            <tr>
              <td colSpan={header.length}>
                <p className="d-flex justify-content-center align-items-center">
                  {error}
                </p>
              </td>
            </tr>
            </tbody>
          ) : plans.length === 0 ? (
            <tbody>
            <tr>
              <td colSpan={header.length}>
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "200px" }}
                >
                  <div>
                    <span className="fw-medium fs-6">No data Found</span>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          ) : (
            plans.map((plan, key) => {
              const statusClass = plan.status ? "active-btn" : "inactive-btn";
              return (
                <tbody key={key}>
                <tr>
                  <td>
                    <div className="workout-sec py-3">


                      <img
                        src={
                          isValidImage(
                            plan?.recipe?.cover_image_url ||
                            plan?.recipe?.thumbnail_image_url
                          )
                            ? plan?.recipe?.cover_image_url ||
                            plan?.recipe?.thumbnail_image_url
                            : fitpro
                        }
                        alt={plan.plan_name || "No image available"}
                        className="w-25 h-25"
                      />
                      <section  className="px-4">
                        <h5>{plan?.recipe?.name}</h5>{" "}
                        <p style={{ color: "#667085" }}>
                          {plan?.recipe?.category}
                        </p>
                      </section>
                    </div>
                  </td>
                  <td>
                      <span className="date-upload">
                        {convertTimestamp(plan.createdAt?._seconds)}
                      </span>
                  </td>
                  <ToogleField  toggleStatus={toggleStatus} plan={plan} statusClass={statusClass}  />


                  <td
                    className={`transition-all duration-500 ${
                      plan.status ? "text-success" : "text-danger"
                    }`}
                  >
                    <select
                      className="form-select mb-3"
                      id={`status-select-${plan.id}`}
                      onChange={(e) =>
                        debouncedStatusUpdate(plan.id, e.target.value)
                      }
                      value={selectedTags[plan?.id] || plan?.recipeTag || ""}
                    >

                      <option value="">Nothing</option>
                      <option value="Featured">Featured</option>
                    </select>
                  </td>
                </tr>
                </tbody>
              );
            })
          )}
        </table>
      </div>
    </div>
  );
};

export default UpdateRecipeTagTable;
